module.exports = __webpack_public_path__ + "app/images/36825_Abbott_Packshot_Beweegpakket_Update_Receptboek.jpg";